import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M4.637 12h14.726c.434 0 .85.176 1.157.488.308.313.48.737.48 1.179V16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2.316a1.7 1.7 0 0 1 .473-1.19A1.64 1.64 0 0 1 4.637 12ZM5.6 5h12.8c.424 0 .831.185 1.131.515S20 6.29 20 6.757V12H4V6.757c0-.466.169-.913.469-1.242.3-.33.707-.515 1.131-.515Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M8.43 9h2.14c.188 0 .374.039.547.115q.263.115.464.327c.133.14.238.306.31.489s.109.379.109.577V12H7v-1.492c0-.4.15-.784.419-1.066A1.4 1.4 0 0 1 8.429 9Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M13.716 9h2.568c.455 0 .892.159 1.213.442.322.282.503.666.503 1.066V12h-6v-1.492c0-.4.18-.784.502-1.066A1.84 1.84 0 0 1 13.717 9Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M4 19v-2M20 19v-2"
    }, null, -1)
  ])))
}
export default { render: render }